<template>
  <div class="welcome-header">
    <div class="header-content">
      <h2 class="title">{{ $t('overview.welcome') }}</h2>
      <p class="subtitle">{{ $t('overview.subtitle') }}</p>
    </div>
    <div class="overview-cards" v-loading="loading">
      <div class="card-item" v-for="(item, index) in overviewList" :key="index" @click="navigateTo(item.routeName)">
        <div class="card-label">{{ item.label }}</div>
        <div class="card-value">{{ formatValue(item.value) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WelcomeHeader',
  data() {
    return {
      loading: false,
      overviewList: [
        { label: this.$t('text.cabinet'), value: '', key: 'cabinet', routeName: 'CabinetList' },
        { label: this.$t('text.equipment'), value: '', key: 'device', routeName: 'EquipmentList' },
        { label: this.$t('ip.publicNetIp'), value: '', key: 'ip', routeName: 'IpAddress' },
        { label: this.$t('bandWidth.bd'), value: '', key: 'bandwidth', routeName: 'BandWidth' },
        { label: this.$t('directConnects.title'), value: '', key: 'directConnect', routeName: 'DirectConnectsList' },
        { label: this.$t('otherResource.title'), value: '', key: 'otherResource', routeName: 'OtherResourceList' }
      ],
    }
  },
  mounted() {
    this.getWelcomeOverview();
  },
  methods: {
    formatValue(val) {
      if (val === null || val === undefined || val === '') {
        return '--';
      }
      return val;
    },
    navigateTo(routeName) {
      if (routeName) {
        this.$router.push({ name: routeName })
      }
    },
    getWelcomeOverview() {
      this.loading = true
      this.$api.getWelcomeOverview().then(res => {
        if (res.data) {
          // 将原始数组转为 以 key 分类到对象
          const overviewData = this._.groupBy(this.overviewList, 'key');
          for (const key in overviewData) {
            overviewData[key][0].value = res.data[key];
          }
          // groupBy 后，数组变成了对象，需要将对象转为数组
          this.overviewList = this._.flatMap(overviewData);
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.welcome-header {
  background: linear-gradient(90deg, rgba(44, 104, 255, 0.1) 0%, rgba(255, 255, 255, 0.1) 100%), #FFF;
  padding: 24px;
  border-radius: 8px;
  border: 1px solid #fff;

  .header-content {
    margin-bottom: 16px;

    .title {
      font-size: 20px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      margin: 8px 0 8px 0;
    }

    .subtitle {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.45);
      margin: 0;
    }
  }

  .overview-cards {
    display: flex;
    gap: 24px;

    .card-item {
      flex: 1;
      padding: 16px;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      // min-height: 50px;
      border: 1px solid rgba(0, 0, 0, 0.06);
      // background: #FFF;
      background: linear-gradient(90deg, rgba(47, 100, 232, 1) 0%, rgba(66, 81, 228, 1) 100%);
      color: #FFF;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        border-color: #1D41FF;
        background-color: #EBF5FF;
        box-shadow: 0 3px 8px 3px rgba(0, 0, 0, 0.04), 0 2px 6px 0 rgba(0, 0, 0, 0.03), 0 1px 4px -3px rgba(0, 0, 0, 0.02);
      }

      .card-label {
        font-size: 12px;
        // color: rgba(0, 0, 0, 0.85);
      }

      .card-value {
        font-size: 18px;
        font-weight: 600;
        padding-top: 14px;
        // color: rgba(0, 0, 0, 0.65);
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/resourceOverview/components/WelcomeHeader.vue